export default __webpack_public_path__ + "static/media/Giuria.bc8eeaa5.jpg";